module.exports = __webpack_public_path__ + "img/guess_right_nor.992f0bb0.png";